var map = {
	"./icon_back_active.png": "df6f",
	"./icon_clear_active.png": "d3dd",
	"./icon_edit1_active.png": "5cd3",
	"./icon_edit_active.png": "86c3",
	"./icon_me_active.png": "22ca",
	"./icon_wrong_active.png": "20bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d08";